export class EmergencySchedule {

    activityId: number;
    activityName: string;
    groupName: string;
    tierName: string;
    checked: boolean = false;
    staffNeeded: number;
    scheduleId: number;
    isAdHocActivity: boolean;
    groupLocationCount: number;

    constructor() { }
}